import React, {useContext, useEffect, useState} from "react";
import {Link, useNavigate, useParams} from "react-router-dom";
import Swal from "sweetalert2";
import api from "../../../services/api";
import {MainContext} from "../../../context/MainContext";
import Select from "react-select";

export default function EventCategoriesForm() {
    const navigate = useNavigate()
    const {setPageTitle, setLoading} = useContext(MainContext)

    let {id, eventId} = useParams()
    const [categoryName, setCategoryName] = useState<string>('');
    const [genre, setGenre] = useState<string>('M');
    const [grade, setGrade] = useState<string>('');
    const [minScore, setMinScore] = useState<number>(0);
    const [maxScore, setMaxScore] = useState<number>(0);
    const [active, setActive] = useState<boolean>(true);
    const [eventTypeId, setEventTypeId] = useState<any>(eventId);

    const dispatchEventsObject = {
        "category_name": categoryName,
        "genre": genre,
        "grade": grade,
        "min_score": minScore,
        "max_score": maxScore,
        "active": active,
        "event_type_id": eventTypeId,
    }

    const GenreOptins = [
        {label: 'Masculino', value: 'M'},
        {label: 'Feminino', value: 'F'}
    ]

    useEffect(() => {
        setPageTitle("Cadastro de Categoria")
        setLoading(true)

        const fetchData = async () => {
            if (id != undefined) {
               await api.get('/api/event-categories/' + id).then(resposta => {
                    const eventCategory = resposta.data

                   setGenre(eventCategory?.genre)
                   setCategoryName(eventCategory?.category_name)
                   setGrade(eventCategory?.grade)
                   setMinScore(eventCategory?.min_score)
                   setMaxScore(eventCategory?.max_score)
                   setActive(eventCategory?.active)
                   setEventTypeId(eventCategory?.event_type_id)
                })
            }
        };

        fetchData().then(setLoading(false))
    },  [])

    const resgister = (evento: React.FormEvent<HTMLFormElement>) => {
        try {
            evento.preventDefault();
            setLoading(true)

            const method:'post' | 'put' = id === undefined ? 'post' : 'put';
            const url:string = id === undefined ? '/api/event-categories' : `/api/event-categories/${id}`;

            api[method](url, dispatchEventsObject)
                .then((result) => {
                    setLoading(false)
                    Swal.fire({
                        title: 'Sucesso!',
                        text: result.data.message,
                        icon: 'success',
                        timer: 3000
                    }).then(() => navigate(`/events/update/${eventTypeId}`));
                })
                .catch(erro => {
                    setLoading(false)
                    Swal.fire({
                        title: 'Erro!',
                        text: erro.response.data.message,
                        icon: 'error',
                    });
                });
        }catch (err: any) {
            setLoading(false)
            Swal.fire({
                title: 'Erro!',
                text: err,
                icon: 'error',
            })
        }

    }

    return (
        <>
            <form onSubmit={resgister} className="row g-3">
                <div className="col-md-12">
                    <div className="form-check form-switch">
                        <input className="form-check-input" type="checkbox" id="active"
                               onChange={evento => setActive(evento.target.checked)} checked={active}/>
                        <label className="form-check-label" htmlFor="active">Ativo</label>
                    </div>
                </div>
                <div className="card">
                    <div className="card-body">
                        <div className="row g-3 mt-2">
                            <div className="col-md-4">
                                <label htmlFor="genre" className="form-label">Gênero<i
                                    className="text-danger"> *</i></label>
                                <Select
                                    defaultValue={GenreOptins[0]}
                                    options={GenreOptins}
                                    value={GenreOptins.find(option => option.value == genre)}
                                    name='genre'
                                    id='genre'
                                    onChange={(data: any) => {
                                        setGenre(data.value)
                                    }}
                                />
                            </div>

                            <div className="col-md-4">
                                <label htmlFor="category_name" className="form-label">Categoria <i
                                    className="text-danger"> *</i></label>
                                <input type="text" className="form-control" id="category_name"
                                       placeholder="Descrição do evento"
                                       onChange={evento => setCategoryName(evento.target.value)}
                                       value={categoryName}/>
                            </div>

                            <div className="col-md-4">
                                <label htmlFor="grade" className="form-label">Classe <i
                                    className="text-danger"> *</i></label>
                                <input type="text" className="form-control" id="grade"
                                       placeholder="Descrição do evento"
                                       onChange={evento => setGrade(evento.target.value)}
                                       value={grade}/>
                            </div>

                            <div className="col-md-6">
                                <label htmlFor="min_score" className="form-label">Pontuação mínima</label>
                                <input type="number" className="form-control" id="min_score"
                                       placeholder="0"
                                       onChange={evento => setMinScore(parseFloat(evento.target.value))}
                                       value={minScore}/>
                            </div>

                            <div className="col-md-6">
                                <label htmlFor="max_score" className="form-label">Pontuação máxima</label>
                                <input type="number" className="form-control" id="max_score"
                                       placeholder="0"
                                       onChange={evento => setMaxScore(parseFloat(evento.target.value))}
                                       value={maxScore}/>
                            </div>


                            <div>
                                <button type="submit" className="btn btn-success me-2">Salvar</button>
                                <Link to={`/events/update/${eventTypeId}`} className="btn btn-danger">Voltar</Link>
                            </div>
                        </div>
                    </div>
                </div>

                {/*{id &&*/}
                {/*    <ListingSubEventType eventTypeId={id}/>*/}
                {/*}*/}
            </form>
        </>
    );
}

